import { render, staticRenderFns } from "./Rolling7App.vue?vue&type=template&id=a70268f8&scoped=true"
import script from "./Rolling7App.vue?vue&type=script&lang=js"
export * from "./Rolling7App.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70268f8",
  null
  
)

export default component.exports